import { ITimeSlot } from '@r1-frontend/api-domru/full-buy/v1/sale-agent/time-slots/dto/ResponseDto';

import { TIME_SLOT_BUSY_STATUS } from '@r1-frontend/service-engineer-visit/constants';
import { hourListForDay } from '@r1-frontend/service-engineer-visit/helpers';
import { TDay } from '@r1-frontend/service-engineer-visit/reducer/initialState';

const transformTimeSlots = (timeSlots: ITimeSlot[]): Record<string, TDay> => {
    const result: Record<string, TDay> = {};

    if (!timeSlots || timeSlots.length === 0) {
        return result;
    }

    for (const slot of timeSlots) {
        const date = slot.date;
        result[date] = {
            date: date,
            weekday: slot.day,
            day: Number(date.split('.')[0]),
            hours: JSON.parse(JSON.stringify(hourListForDay)),
            isFirstDate: Number(date.split('.')[0]) === 1,
        };

        for (const time of slot.time) {
            const [hour] = time.hour_start.split(':');
            const currHour = `${Number(hour)}`;
            const currSlot = result[date].hours[currHour];
            // @todo add try catch for detect problem
            if (currSlot) {
                currSlot.active = time.status !== TIME_SLOT_BUSY_STATUS;
                currSlot.cost = time.cost;
            }
        }
    }

    return result;
};

export default transformTimeSlots;
